import { Button, Card, Loader } from "@dune/ui";
import FileDropUploadAndProcessWithAiInput from "../../../../component/constructionSites/FileDropUploadAndProcessWithAiInput";
import { useRequiredParams } from "../../../../hooks/useRequiredParams";
import { useGetConstructionSiteReceptionFolder } from "../../../../api/queries/constructionSiteReception.queries";
import { useEffect, useState } from "react";
import { useUpdateConstructionSiteReceptionDocuments } from "../../../../api/mutations/constructionSiteReception.mutations";
import { useNavigate } from "react-router-dom";
import { PAGES } from "@dune/types";

type Props = { onPrev: () => void; onNext: () => void };

export const ReceptionStep2Documents = ({ onPrev, onNext }: Props) => {
	const { constructionSiteId } = useRequiredParams<{
		constructionSiteId: string;
	}>();
	const { data: folder, isLoading } = useGetConstructionSiteReceptionFolder(
		Number(constructionSiteId),
	);
	const existingFileIds = folder?.files.map((file) => file.id) ?? [];

	const [currentFileIds, setCurrentFileIds] = useState<string[]>();

	const { mutate: updateDocuments, isPending: isUpdating } =
		useUpdateConstructionSiteReceptionDocuments(Number(constructionSiteId));

	useEffect(() => {
		if (
			currentFileIds === undefined &&
			folder?.files &&
			folder.files.length > 0
		) {
			setCurrentFileIds(folder.files.map((file) => file.id));
		}
	}, [folder, currentFileIds]);

	const navigate = useNavigate();

	return (
		<div className="flex flex-col gap-6">
			<h2 className="text-xl font-semibold text-text-main-blue">
				Déposer les documents du dossier
			</h2>
			<div className="text-gray-500 text-sm">
				Pièce d'identité, plans, DOC, devis, rapports, attestations décennales…
			</div>
			<Card className="p-6">
				{isLoading ? (
					<Loader />
				) : (
					<FileDropUploadAndProcessWithAiInput
						folderId={folder?.id}
						existingFileIds={existingFileIds}
						onUploadedFiles={(fileIds) => {
							setCurrentFileIds((prev) => [...(prev ?? []), ...fileIds]);
						}}
						onDeleteOneFile={(fileId) => {
							setCurrentFileIds((prev) => prev?.filter((id) => id !== fileId));
						}}
						disabled={false}
					/>
				)}
			</Card>
			<div className="flex items-center justify-between mt-2">
				<Button variant="outline" onClick={onPrev}>
					Précédent
				</Button>
				<div className="flex gap-2">
					<Button
						variant="outline"
						isLoading={isUpdating}
						disabled={!currentFileIds || isUpdating}
						onClick={() =>
							currentFileIds &&
							updateDocuments(currentFileIds, {
								onSuccess: () => {
									navigate(PAGES.PROJECTS.show.withParams(constructionSiteId));
								},
							})
						}
					>
						Enregistrer et fermer
					</Button>
					<Button
						onClick={() => {
							updateDocuments(currentFileIds ?? [], {
								onSuccess: () => {
									onNext();
								},
							});
						}}
						disabled={!currentFileIds || isUpdating}
						isLoading={isUpdating}
					>
						Suivant
					</Button>
				</div>
			</div>
		</div>
	);
};

export default ReceptionStep2Documents;
